// extracted by mini-css-extract-plugin
module.exports = {"root":"FormSubmitBar_root__3BidT"};